<template>
    <q-modal v-model="visible" content-css="width: 800px;">
        <div class="q-pa-lg">
            <form autocomplete="off" @submit.prevent="saveProjectConfig">
                <q-field>
                    <q-input stack-label="Версия БД" type="text"
                             v-model="projectConfig.database_id"/>
                </q-field>
                <q-field>
                    <q-input stack-label="Версия бекенда" type="text"
                             v-model="projectConfig.backend_name"
                             :error="$v.projectConfig.database_id.$error"/>
                </q-field>
            </form>
            <div class="q-mt-lg row justify-end items-center">
                <div>
                    <q-btn @click="saveProjectConfig()" label="Сохранить" color="primary"/>
                    <q-btn @click="visible = false" color="primary" flat label="Отмена"/>
                </div>
            </div>
        </div>
    </q-modal>
</template>

<script>
import _ from 'lodash'

import {required} from 'vuelidate/lib/validators'

import {QBtn, QField, QInput, QModal, QToggle} from 'quasar'

import api from 'mixins/api'

export default {
  name: 'UpdateMcpProjectConfig',
  components: {
    QField,
    QInput,
    QBtn,
    QModal,
    QToggle,
  },
  mixins: [
    api,
  ],
  props: {
    value: Boolean,
    projectConfig: {
      type: Object,
      default () {
        return {
          database_id: '',
          backend_name: '',
        }
      },
    },
  },
  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      },
    },
  },
  validations: {
    projectConfig: {
      database_id: {required},
      backend_name: {required},
    },
  },
  methods: {
    saveProjectConfig () {
      this.$v.projectConfig.$touch();
      if (this.$v.projectConfig.$error) {
        this.$q.notify('Please review fields again.');
        return;
      }
      this.$http.put(`/api/v1.0/project_configs/${this.projectConfig.id}`, this.projectConfig).then(response => {
        this.$q.notify({
          message: 'Сохранено',
          type: 'positive'
        });
        this.visible = false;
        this.$emit('save');
      }).catch(error => {
        _.forIn(error.response.data.errors, (value, key) => {
          this.$q.notify({message: value[0], type: 'negative'});
        });
      });
    },
  },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/McpProjectConfigs/UpdateMcpProjectConfig.vue